import { Link, useLocation } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from "@/components/ui/sheet"
import { Menu } from "lucide-react"
import { ThemeToggle } from "@/components/ui/theme-toggle"

export function MobileMenu() {
  const { pathname } = useLocation()

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden ml-2">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="flex flex-col">
        <SheetHeader className="text-left">
          <SheetTitle className="text-2xl font-bold">WithWords</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col gap-4 mt-8">
          <Button
            variant="ghost"
            asChild
            className={`justify-start ${pathname === "/features" ? 'bg-accent text-accent-foreground' : ''}`}
          >
            <Link to="/features">Features</Link>
          </Button>
          <Button
            variant="ghost"
            asChild
            className={`justify-start ${pathname === "/pricing" ? 'bg-accent text-accent-foreground' : ''}`}
          >
            <Link to="/pricing">Pricing</Link>
          </Button>
          <Button
            variant="ghost"
            asChild
            className={`justify-start ${pathname.startsWith('/blog') ? 'bg-accent text-accent-foreground' : ''}`}
          >
            <Link to="/blog">Blog</Link>
          </Button>
          <Button
            variant="ghost"
            asChild
            className={`justify-start ${pathname === '/contact' ? 'bg-accent text-accent-foreground' : ''}`}
          >
            <Link to="/contact">Contact</Link>
          </Button>
          <div className="h-px bg-border my-4" />
          <Button variant="ghost" asChild className="justify-start">
            <Link to="https://app.withwords.app/signin/">Sign In</Link>
          </Button>
          <Button asChild>
            <Link to="https://app.withwords.app/signup/">Get Started</Link>
          </Button>
          <div className="flex items-center justify-between mt-4">
            <span className="text-sm text-muted-foreground">Toggle theme</span>
            <ThemeToggle />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
